/**
 * Shared section rhythm for the public pages: full-bleed band with a top
 * border, optional card-tone background (`alt`), and a centered max-w-6xl
 * content well. `SectionHead` is the standard eyebrow / title / body lead-in.
 */
export function PublicSection({ id, alt = false, className = '', innerClassName = '', children }) {
  return (
    <section
      id={id}
      className={`scroll-mt-20 border-t border-border ${alt ? 'bg-card' : ''} ${className}`.trim()}
    >
      <div className={`mx-auto max-w-6xl px-5 py-16 ${innerClassName}`.trim()}>{children}</div>
    </section>
  )
}

export function SectionHead({ eyebrow, title, body, className = '' }) {
  return (
    <div className={`max-w-2xl ${className}`.trim()}>
      {eyebrow ? (
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">
          {eyebrow}
        </p>
      ) : null}
      <h2 className={`${eyebrow ? 'mt-3 ' : ''}text-2xl font-semibold tracking-tight sm:text-3xl`}>
        {title}
      </h2>
      {body ? <p className="mt-3 text-base leading-7 text-muted-foreground">{body}</p> : null}
    </div>
  )
}
